import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {InsolesModelDataService} from './insolesModel.data.service';
import {InsolesModelSummaryModel} from "../../../api/entity/insolesModelSummary.model";
import {InsolesModelSummaryConverter} from "../../../api/entity/insolesModelSummary.converter";
import {InsolesModelModel} from "../../../api/entity/insolesModel.model";

@Injectable()
export class InsolesModelSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    InsolesModelSummaryModel,
    InsolesModelSummaryConverter,
    InsolesModelModel> {
    constructor(dataService: InsolesModelDataService, converter: InsolesModelSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): InsolesModelModel {
        return new InsolesModelModel();
    }
}
